import React from "react";
import Footer from "../../components/Hero/Footer";
import Main from "./Main";
import Whymatters from "./Whymatters";
import MakeDiff from "./MakeDiff";
import AsseteyeBackground from "./AsseteyeBackground";
import Metrics from "./Metrics";
import Navbar from "../../components/Hero/Navbar";
import OurStorySection from "./OurStorySection";
import Team from "./Team";
export default function About() {
  return (
    <div className="min-h-screen bg-[#f6fcff]">
      <Navbar />
      <Main />
      <Metrics />
      <Whymatters />
      <MakeDiff />
      <OurStorySection />
      <Team />
      <Footer />
    </div>
  );
}
